












































































import { Vue, Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import DisplayMixin from '@/mixins/displayTitle'
import { getLangType } from '@/api/common'
import { getSpecialLangList, editSpecialLang } from '@/api/content/content-special/special'
import { checkNoneString } from '@/utils/tool'
const domain = 'http://pics.tutuapp.com/'

@Component({
  name: 'ContentSpecialTranslate'
})
export default class extends mixins(DisplayMixin) {
  private showSelect = true
  private lang = ''
  private type: 'save' | 'commit' = 'save'
  private id = 0
  private draftId: number = 0
  private options: any[] = []
  private contentList: Array<any> = []
  private langCodeList: string[] = []
  private tabIndex = 0
  private domain = domain
  // life
  created() {
    this.id = Number(this.$route.query.id) || 0
    this.getLangType()
    this.getSpecialLangList()
  }
  // methods
  async getSpecialLangList() {
    let res: any = await getSpecialLangList({
      specialId: this.$route.query.id
    })
    if (res.data.dataList.length === 0) {
      this['$message'].error('没有应用信息,请先添加相关应用信息')
      return
    }
    let list: any[] = res.data.dataList
    list.forEach((item, index) => {
      // console.log(item.icon)
      item.icon = domain + item.icon
      this.langCodeList.push(item.lang)
    })
    console.log(list)
    this.contentList = list
  }
  async getLangType() {
    let res = await getLangType()
    this.options = res.data
  }
  async editSpecialLang() {
    let res: any = await editSpecialLang({
      specialId: this.id,
      type: this.type,
      draftId: this.draftId,
      descList: this.contentList.map(item => {
        return {
          specialId: item.specialId,
          lang: item.lang,
          langName: item.langName,
          name: item.name,
          desc: item.desc,
          icon: item.icon.split(domain).pop()
        }
      })
    })
    if (res.status.code === 0) {
      if (this.type === 'save') {
        this['$message']('已保存至草稿箱!')
      } else {
        this['$message'].success('提交成功!')
      }
    } else {
      this['$message'].error('提交失败，请稍后重试或联系相关人员!')
    }
  }
  handleCancel() {
    this['$router'].go(-1)
  }
  toggleLang(i: number) {
    this.tabIndex = i
  }
  deleteLang(i: number) {
    let lang = this.contentList[i]['lang']
    console.log(lang)
    this.contentList.splice(i, 1)
    this.langCodeList.splice(this.langCodeList.indexOf(lang), 1)
    this.tabIndex = 0
  }
  handleDisplay() {
    this.showSelect = !this.showSelect
  }
  handleSelect(v: string) {
    this.showSelect = false
    if (this.langCodeList.includes(v)) {
      this['$message'].error('该语言已存在!')
    } else {
      let list = this.options.filter(item => item.code === v)
      this.contentList.push({
        specialId: this.id,
        lang: v,
        langName: list[0].name,
        name: '',
        desc: '',
        icon: ''
      })
    }
    this.langCodeList.push(v)
    this.lang = ''
    this.tabIndex = this.langCodeList.length - 1
  }
  setDefaultLang(i: number) {
    if (i === 0) {
      this['$message'].warning('该语言已为默认语言!')
    } else {
      this.contentList.splice(0, 1, ...this.contentList.splice(i, 1, this.contentList[0]))
    }
  }
  handeSubmit(type: 'save' | 'commit') {
    this.type = type
    // 非空验证
    let isEmpty = this.contentList.length === 0
    let isNone = this.contentList.some(item => checkNoneString(item, ['lang', 'langName']))
    if (isNone || isEmpty) {
      this['$message'].error('数据缺失,请填写完整数据!')
    } else {
      this.editSpecialLang()
    }
  }
  // computed
  get imgType() {
    return this.$route.query.platform === 'ios' ? 1 : 2
  }
}
